import { useTranslation } from "react-i18next";

import type { Course } from "@/api";
import { coursePrice } from "@/lib/price";
import { cn } from "@/lib/utils";

import { Money } from "../money";

interface CoursePriceTagProps {
  course: Pick<Course, "priceType" | "priceUzs" | "discountPriceUzs" | "discountEndDate">;
  className?: string;
}

/**
 * Kurs narxi — talaba HOZIR to'laydigan summa, chegirma bo'lsa eski narx
 * chizilgan holda yonida. Bepul kurs "Bepul" deb yoziladi, "0 so'm" emas.
 */
export const CoursePriceTag = ({ course, className }: CoursePriceTagProps) => {
  const { t } = useTranslation();
  const { isFree, price, effective, hasDiscount, percentOff } = coursePrice(course);

  if (isFree) return <span className={cn("font-medium", className)}>{t("MODERATION.FREE")}</span>;

  return (
    <span className={cn("inline-flex flex-wrap items-baseline gap-x-1.5", className)}>
      <Money value={effective} className="font-medium" />
      {hasDiscount && (
        <>
          <Money value={price} className="text-muted-foreground text-xs line-through" />
          <span className="text-warning text-xs font-semibold">−{percentOff}%</span>
        </>
      )}
    </span>
  );
};
